import { Types } from './actionTypes';

export const ActionCreators = {
  trip_login: (trip) => ({ type: Types.TRIP_LOGIN, payload: { trip } }),
  login: (user) => ({ type: Types.LOGIN, payload: { user } }),
  logout: (user) => ({ type: Types.LOGOUT, payload: { user } })
}